@if (form) {
    <div class="slots-edit row" [formGroup]="form">
        <div class="col-sm-2 bolded">
            {{ "CampCareDayEdit.Slots" | translate }}
        </div>
        <div class="col">
            <div class="row">
                <div class="col slot-picker">
                    <bcui-time-picker
                        formControlName="timeFrom"
                    ></bcui-time-picker>
                    -
                    <bcui-time-picker
                        formControlName="timeTo"
                    ></bcui-time-picker>
                    <button
                        class="btn btn-success btn-sm add-btn"
                        bcClick
                        (clicked)="addSlot()"
                    >
                        Add
                    </button>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col text-center">
                    @for (slot of slots; track slot) {
                        <div class="slot">
                            <span
                                >{{ slot.from | timeDisplay }} -
                                {{ slot.to | timeDisplay }}</span
                            >
                            <span class="remove-img" (click)="removeSlot(slot)"
                                >x</span
                            >
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}
